import { Component, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonIcon, NavController } from '@ionic/angular/standalone';
import { addIcons } from 'ionicons';
import { closeOutline } from 'ionicons/icons';
import { ButtonComponent } from 'src/app/components/primitives/button/button.component';
import { AmplitudeService } from 'src/app/services/amplitude.service';
import { NativeService } from 'src/app/services/native.service';

@Component({
    selector: 'app-add-script-card',
    templateUrl: './add-script-card.component.html',
    styleUrls: ['./add-script-card.component.scss'],
    imports: [IonIcon, CommonModule, ButtonComponent]
})
export class AddScriptCardComponent {
  private $amplitude = inject(AmplitudeService);
  private $native = inject(NativeService);
  private navCtrl = inject(NavController);
  
  public isWeb = this.$native.isWeb;
  public visible = signal<boolean>(true);

  constructor() {
    addIcons({ closeOutline })
  }
  
  addScript() {
    this.navCtrl.navigateForward(['/add-script']);
    this.$amplitude.track('ADD_SCRIPT_CTA', {
      origin: "MyScripts",
      content: "Promo",
      UI: "PrimaryCTA_Button",
    });
  }

  hide() {
    this.visible.set(false);
    this.$amplitude.track('PROMO_PROMPT_CLOSED', {
      origin: "MyScripts",
      content: "Promo",
      UI: "crossTopRight",
    });
  }
}